// extracted by mini-css-extract-plugin
export default {"lineButtons":"_1z-BT","betsCount":"iV7rn","singleEventButtons":"_1HAEN"};